import { AppBox } from "../../../../../commons/components";
import { User } from "../../../../../commons/models/user";
import { toTitleCase } from "../../../../../commons/utilities/string-utils";

interface TeamCoachAddConfirmProps {
  user: User;
}
export default function TeamCoachAddConfirm({ user }: TeamCoachAddConfirmProps) {
  return (
    <AppBox displayBlock>
      Do you want to add <strong>“{toTitleCase(user.fullName)}” </strong> to the team as coach?
    </AppBox>
  );
}
